import { z } from 'zod';

import { BULK_BIDDING_CSV_FIELDS, LINK_WITH_ENQUIRY_ID_REGEX } from './bulkBiddingCSV.const';
import type { MotorwayVehicleUrl } from './validateCSVEntries.types';

export const BulkBiddingUploadCSVSchema = z.object({
	[BULK_BIDDING_CSV_FIELDS.BID_AMOUNT]: z.preprocess((val) => Number(val), z.number().multipleOf(1).positive()),
	[BULK_BIDDING_CSV_FIELDS.VEHICLE_LINK]: z.custom<MotorwayVehicleUrl>(
		(val): val is MotorwayVehicleUrl => typeof val === 'string' && LINK_WITH_ENQUIRY_ID_REGEX.test(val),
	),
});
